import React, { useState, useEffect } from 'react';
import '../App.css'
import MessageForm from '../components/MessageForm';
import CallRoom from '../components/CallRoom';
import { useSocket } from "../contexts/SocketContext";
import { useAuthContext } from '../contexts/AuthContext.js';
import { useNotifications } from "../stores/NotificationsStore.js";

import { useRtcStore } from "../stores/rtcStore";

/**
 * props:
 * - selectedProjectData: { case_name, ... }
 * - selectedmeeting: { id, start, ... }
 * - socket: 已連線的 socket.io client（例如 io(API_ORIGIN, { ... })）
 */
const MeetingChat = ({ selectedProjectData, selectedmeeting }) => {
  const { socket, setAuthToken } = useSocket();
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const status = useRtcStore((s) => s.meetingStatusById[selectedmeeting.id]);
  const setMeetingStatus = useRtcStore((s) => s.setMeetingStatus);

  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null); // "host" | "participant" | null
  // const [status, setStatus] = useState(null); // "approved" | "pending" | "rejected" | "none"
  const [roomName, setRoomName] = useState("");
  const [inCall, setInCall] = useState(false);
  const [requestingJoin, setRequestingJoin] = useState(false);
  const [error, setError] = useState(null);

  // 給主持人用：收到 join_request 的列表
  const [joinRequests, setJoinRequests] = useState([]);

  // 假設 user_id 存在 sessionStorage，你可以改成你自己的 auth 來源
  // const currentUserId = sessionStorage.getItem("user_id");
  const currentUserId = user.user_id;

  // ---- 1) 進頁面先查詢我在這個 meeting 的角色／狀態 ----
  useEffect(() => {
    console.log("Meeting selectedmeeting:", selectedmeeting);
    console.log("selectedmeeting?.id", selectedmeeting?.id);
    console.log("currentUserId", currentUserId);
    if (!selectedmeeting?.id || !currentUserId) return;

    async function fetchMyMeetingInfo() {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(`http://localhost:5000/api/meetings/${selectedmeeting.id}/me`, {
          credentials: "include",
        });
        const data = await res.json();
        if (!res.ok) {
          setError(data.error || "取得會議資訊失敗");
          setRole(null);
          // setStatus("none");
      
          setMeetingStatus(selectedmeeting.id, "none");

          setRoomName("");
          return;
        }

        setRole(data.role); // host / participant / null
        // setStatus(data.status); // approved / pending / none ...

          setMeetingStatus(selectedmeeting.id, data.status);
        setRoomName(data.room_name || `meeting_${selectedmeeting.id}`);
      } catch (err) {
        console.error("fetchMyMeetingInfo error", err);
        setError("取得會議資訊失敗");
      } finally {
        setLoading(false);
      }
    }

    fetchMyMeetingInfo();
    setInCall(false); // 切換 meeting 時重置
    setJoinRequests([]);
  }, [selectedmeeting, currentUserId, status]);

  // ---- 2) 設定 Socket 事件：join_request / join_approved / join_rejected ----
  // useEffect(() => {
  //   if (!socket || !selectedmeeting?.id) return;

  //   const meetingId = selectedmeeting.id;

  //   // 被批准的人會收到
  //   const handleJoinApproved = (payload) => {
  //     if (payload.kind !== "meeting") return;
  //     if (payload.meeting_id !== meetingId) return;
  //     console.log("rtc:accepted", payload);
  //     setStatus("approved");
  //     // 這裡可以選擇自動進入會議，也可以只改狀態，給使用者自己按「進入會議」
  //     // setInCall(true);
  //   };

  //   const handleJoinRejected = (payload) => {
  //     if (payload.kind !== "meeting") return;
  //     if (payload.meeting_id !== meetingId) return;
  //     console.log("rtc:rejected", payload);
  //     setStatus("rejected");
  //     alert("主持人拒絕你加入這場會議");
  //   };

    // 只有主持人才真的會看到 UI，但這裡先收，再由 UI 決定要不要顯示
    // const handleJoinRequest = (payload) => {
    //   if (payload.meeting_id !== meetingId) return;
    //   console.log("meeting:join_request", payload);
    //   // 只有 host / co_host 才顯示
    //   setJoinRequests((prev) => {
    //     // 避免重複塞入
    //     const exists = prev.some(
    //       (r) => r.from_user_id === payload.from_user_id
    //     );
    //     if (exists) return prev;
    //     return [...prev, payload];
    //   });
    //   console.log("joinRequests:", joinRequests);

    //   const id = `join_${Date.now()}`;
    //   useNotifications.getState().add({
    //     id,
    //     type: "joinRequest",
    //     title: "會議加入請求",
    //     message: `${payload.from_user_name} 想加入會議`,
    //     actions: [
    //       {
    //         label: "同意",
    //         onClick: () => {
    //           socket.emit("meeting:approve_join", {
    //             meeting_id: payload.meeting_id,
    //             user_id: payload.from_user_id,
    //           });
    //         },
    //       },
    //       {
    //         label: "拒絕",
    //         onClick: () => {
    //           socket.emit("meeting:reject_join", {
    //             meeting_id: payload.meeting_id,
    //             user_id: payload.from_user_id,
    //           });
    //         },
    //       },
    //     ],
    //   });

    // };

    // socket.on("rtc:accepted", handleJoinApproved);
    // socket.on("rtc:rejected", handleJoinRejected);
    // socket.on("meeting:join_request", handleJoinRequest);

  //   return () => {
  //     socket.off("rtc:accepted", handleJoinApproved);
  //     socket.off("rtc:rejected", handleJoinRejected);
  //     socket.off("meeting:join_request", handleJoinRequest);
  //   };
  // }, [socket, selectedmeeting]);

  // ---- 3) 按下「請求加入」 ----
  const handleRequestJoin = async () => {
    if (!selectedmeeting?.id) return;
    try {
      setRequestingJoin(true);
      const res = await fetch(
        `http://localhost:5000/api/meetings/${selectedmeeting.id}/join-request`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            note: "我想加入這場會議",
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        alert(data.error || "請求加入失敗");
        return;
      }
      // setStatus(data.status || "pending");
      setMeetingStatus(selectedmeeting.id, "rejected");
      
    } catch (err) {
      console.error("handleRequestJoin error", err);
      alert("請求加入失敗");
    } finally {
      setRequestingJoin(false);
    }
  };

  // ---- 4) 主持人：同意 / 拒絕加入 ----
  const handleApproveJoin = (req) => {
    if (!socket || !selectedmeeting?.id) return;
    // socket.emit("meeting:approve_join", {
    //   meeting_id: selectedmeeting.id,
    //   user_id: req.from_user_id,
    // });
    socket.emit("rtc:approve_join", {
      kind: "meeting",
      id: selectedmeeting.id,
      user_id: req.from_user_id
    });
    // UI 上直接移除這個請求
    setJoinRequests((prev) =>
      prev.filter((r) => r.from_user_id !== req.from_user_id)
    );
  };

  const handleRejectJoin = (req) => {
    if (!socket || !selectedmeeting?.id) return;
    // socket.emit("meeting:reject_join", {
    //   meeting_id: selectedmeeting.id,
    //   user_id: req.from_user_id,
    // });

    socket.emit("rtc:reject_join", {
      kind: "meeting",
      id: selectedmeeting.id,
      user_id: req.from_user_id
    });
    setJoinRequests((prev) =>
      prev.filter((r) => r.from_user_id !== req.from_user_id)
    );
  };

  // ---- 5) 進入會議（顯示 CallRoom） ----
  const handleEnterMeeting = () => {
    setInCall(true);
  };

  // ---- UI 區塊 ----

  const renderControls = () => {
    // 主持人
    if (role === "host" && status === "approved") {
      if (!inCall) {
        return (
          <button onClick={handleEnterMeeting}>
            進入主持會議
          </button>
        );
      }
      return null; // 已經顯示 CallRoom 在下面
    }

    // 一般參與者，已批准
    if (role === "participant" && status === "approved") {
      if (!inCall) {
        return <button onClick={handleEnterMeeting}>進入會議</button>;
      }
      return null;
    }

    // 已送出加入請求
    if (status === "pending") {
      return <p>已送出加入請求，等待主持人同意...</p>;
    }

    // 被拒絕
    if (status === "rejected") {
      return <p>主持人已拒絕你的加入請求</p>;
    }

    // 尚未加入
    return (
      <button onClick={handleRequestJoin} disabled={requestingJoin}>
        {requestingJoin ? "送出請求中..." : "請求加入會議"}
      </button>
    );
  };

  const meetingDateStr = selectedmeeting?.start
    ? new Date(selectedmeeting.start).toLocaleString("zh-TW", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    : "-";

  return (
    <div className="wrapper">
      <h2>Case Name: {selectedmeeting.case_name}</h2>
      <h3>Meeting Date: {meetingDateStr}</h3>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {loading ? (
        <p>載入會議資訊中...</p>
      ) : (
        <>
          <p>
            你的身分：{role || "尚未加入"}（狀態：{status || "none"}）
          </p>

          {/* 控制區：進入會議 / 請求加入 / 等待 */}
          {renderControls()}

          {/* 主持人看到的加入請求列表 */}
          {role === "host" && joinRequests.length > 0 && (
            <div
              style={{
                marginTop: "16px",
                padding: "8px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <h4>等待審核的加入請求：</h4>
              {joinRequests.map((req) => (
                <div
                  key={req.from_user_id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "4px 0",
                  }}
                >
                  <div>
                    <strong>{req.from_user_name}</strong> 想加入這場會議
                    {/* {req.note && <span>（備註：{req.note}）</span>} */}
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button onClick={() => handleApproveJoin(req)}>
                      同意
                    </button>
                    <button onClick={() => handleRejectJoin(req)}>
                      拒絕
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* 真的開始通話：顯示 CallRoom */}
          {inCall && (
            <div style={{ marginTop: "16px" }}>
              {/* <CallRoom
                userId={String(currentUserId || "")}
                roomName={roomName || `meeting_${selectedmeeting.id}`}
                mode="video" // 或 "video"
              /> */}
              <CallRoom kind="meeting" id={selectedmeeting.id} mode="video" />

            </div>
          )}

          {/* 你原本的聊天區，如果要放的話 */}
          {/* <MessageForm ... /> */}
        </>
      )}
    </div>
  );
};

export default MeetingChat;






// const MeetingChat = ({ selectedProjectData, selectedmeeting
//   // , topics
// }) => {
//   const { socket, connected } = useSocket();
//   const [isSidebarVisible, setIsSidebarVisible] = useState(false);

//   // if (!selectedProjectData) return <div>Loading...</div>;

//   useEffect(() => {
//     if (!socket || !connected) return;

//     const handleJoinApproved = (payload) => {  };

//     socket.on("meeting:join_approved", handleJoinApproved);

//     return () => {
//       socket.off("meeting:join_approved", handleJoinApproved);
//     };

//   }, [socket, connected, selectedmeeting])

//   return (
//     <div className="wrapper">
//       <h2>Case Name: {selectedProjectData.case_name}</h2>
//       <h3>Meeting Date: {new Date(selectedmeeting.start)
//         .toLocaleString("zh-TW", {
//           year: "numeric",
//           month: "2-digit",
//           day: "2-digit",
//           hour: "2-digit",
//           minute: "2-digit",
//           hour12: false,  // ✅ 24 小時制
//         })}</h3>
//       <CallRoom
//         userId="alice"
//         roomName="test-room"
//         mode="video"
//       />
//       {/* <h3>Topic Name: {selectedtopic.title}</h3> */}
//       {/* <MessageForm
//                     isSidebarVisible={isSidebarVisible}
//                     setIsSidebarVisible={setIsSidebarVisible}
//                     selectedProjectData={selectedProjectData}
//                     selectedmeeting={selectedmeeting}
//                     // topics={topics}
//                 /> */}

//       {/* {selectedProjectData.tasks.map((task) => (
//             <div key={task.task_id} style={{ marginBottom: '40px' }}>
//               <h3>Project Name: {task.project_name}</h3>
//               <table border="1" cellPadding="8" style={{ borderCollapse: 'collapse', width: '100%' }}>
//                 <thead>
//                   <tr>
//                     <th>任務名稱</th>
//                     <th>負責人</th>
//                     <th>到期日</th>
//                     <th>狀態</th>
//                     <th>備註</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {task.variants.map(variant =>
//                     variant.details.map(detail => (
//                       <tr key={detail.detail_id}>
//                         <td>{variant.task_name}</td>
//                         <td>{detail.people}</td>
//                         <td>{detail.due_date}</td>
//                         <td>{detail.status}</td>
//                         <td>{detail.note}</td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           ))} */}
//     </div>
//   );
// };

// export default MeetingChat;
